import React, { useState, useEffect } from 'react';
import './UserDetailsPage.css';
import { authFetch } from '../api';
import UserInfoCard from '../components/UserInfoCard/UserInfoCard';

const UserDetailsPage = ({ userId, onBack }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const resp = await authFetch(`https://demo.api.da-capital.io/v1/users/admin/${userId}`, {
          method: 'GET',
        });
        if (!resp.ok) {
          throw new Error(`HTTP error ${resp.status}`);
        }
        const result = await resp.json();
        if (result && result.data) {
          setUser(result.data);
        } else {
          setUser(result);
        }
        setError(null);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUser();
    }
  }, [userId]);

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '0.00';
    return parseFloat(amount).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
  };

  return (
    <div className="user-details-container">
      <div className="header">
        <button className="back-button" onClick={onBack}>
          <i className="fas fa-arrow-left" /> Back
        </button>
        <h1 className="page-title">User Information</h1>
      </div>
      {loading ? (
        <div className="loading">Loading...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : user ? (
        <div className="user-details">
          <div className="cards-grid">
            <div className="card">
              <UserInfoCard
                user={user}
                onUpdate={(data) =>
                  setUser((prev) => ({
                    ...prev,
                    ...data,
                  }))
                }
              />
            </div>
            <div className="card">
              <h3 className="section-title" style={{ borderBottom: 'none', padding: 0, marginBottom: '12px' }}>
                Total Balance
              </h3>
              <div className="balance-value">{formatCurrency(user.totalBalance)}</div>
            </div>
          </div>

          {user.documents && (
            <div className="section">
              <div className="section-title">Documents</div>
              <div className="section-content">
                <table className="details-table">
                  <tbody>
                    {Object.entries(user.documents).map(([k, v]) => (
                      <tr key={k}>
                        <th>{k}</th>
                        <td>{v || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {Array.isArray(user.fortis) && user.fortis.length > 0 && (
            <div className="section">
              <div className="section-title">Fortis</div>
              <div className="section-content">
                <table className="details-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th className="right">Initial</th>
                      <th className="right">Current</th>
                      <th className="right">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.fortis.map((f) => (
                      <tr key={f.id}>
                        <td>{f.title}</td>
                        <td className="right">{formatCurrency(f.initialBalance)}</td>
                        <td className="right">{formatCurrency(f.currentBalance)}</td>
                        <td className="right">{formatCurrency(f.profitTotal)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {Array.isArray(user.primes) && user.primes.length > 0 && (
            <div className="section">
              <div className="section-title">Primes</div>
              <div className="section-content">
                <table className="details-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th className="right">Initial</th>
                      <th className="right">Current</th>
                      <th className="right">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.primes.map((p) => (
                      <tr key={p.id}>
                        <td>{p.title}</td>
                        <td className="right">{formatCurrency(p.initialBalance)}</td>
                        <td className="right">{formatCurrency(p.currentBalance)}</td>
                        <td className="right">{formatCurrency(p.profitTotal)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {Array.isArray(user.referrals) && user.referrals.length > 0 && (
            <div className="section">
              <div className="section-title">Referrals</div>
              <div className="section-content">
                {user.referrals.map((r) => (
                  <div key={r.id} className="referral-item">
                    <div>
                      <span>ID: {r.id}</span>
                      <span style={{ marginLeft: 8 }}>{r.fio}</span>
                    </div>
                    <button className="view-button">
                      <i className="fas fa-eye" /> View
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="error">No data</div>
      )}
    </div>
  );
};

export default UserDetailsPage;
